  
    import { distanceUnitArray, googleApiKey } from "../utils/constants";
    const axios = require('axios').default;
    
    import  $ from "jquery";	

    export const getDistanceUnit = (countryName) => {
		  let distanceUnit;
	   	  for (let x in distanceUnitArray){
	   		  if(distanceUnitArray[x].country == countryName){
	   			distanceUnit = distanceUnitArray[x].unit
	   		  }
	   	  }
	   	  return distanceUnit;
	}

    export const getLocationsDetails = async() => {
        return new Promise((resolve, reject) => {  
            // navigator.permissions.query({ name: 'geolocation' })
            // 	.then(response => {
            // 		if(response.state === "denied"){
            // 			reject(1)
            // 		}
            // 	})
                
            setTimeout(() => {
                reject(1);
            }, 3000)

            if(document.readyState === "complete"){
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(async(position)=>{
                        const userLocation = { latitude: position.coords.latitude, longitude: position.coords.longitude };
                        const latlng = { lat: position.coords.latitude, lng: position.coords.longitude };
                        let geocoder = new google.maps.Geocoder();
                        await geocoder.geocode( { 'latLng' : latlng }).then((response) => {
                            resolve({locationDetails: response, userLocation: userLocation});
                        })
                        .catch((error) => {
                            reject({"respCode": 400, "message": error})
                        });                      
                    });            
                }  else {
                    reject(false)
                }          
            } else {
                window.onload = () => {
                    if (navigator.geolocation) {
                        navigator.geolocation.getCurrentPosition(async(position)=>{
                            const userLocation = { latitude: position.coords.latitude, longitude: position.coords.longitude };
                            const latlng = { lat: position.coords.latitude, lng: position.coords.longitude };
                            let geocoder = new google.maps.Geocoder();
                            await geocoder.geocode( { 'latLng' : latlng }).then((response) => {
                                resolve({locationDetails: response, userLocation: userLocation});
                            })
                            .catch((error) => {
                                reject({"respCode": 400, "message": error})
                            });    
                            });            
                    } else {
                        reject(false);
                    }  
                }
            }     
        })        
    }
	
	export const reqAddressLatLng = async(address) => {
		return new Promise((resolve, reject) => { 
			let geocoder = new google.maps.Geocoder();
			
			geocoder.geocode( { 'address': address}, function(results, status) {
				if (status == 'OK') {
					const userLocation = { latitude: results[0].geometry.location.lat(), longitude: results[0].geometry.location.lng(), address: results[0].formatted_address };
					resolve(userLocation);	    
				} else {
					reject("Make sure the postal code is valid")
				}
			});
		})
	};

	// Singapore OneMap API for accurate address lookup (via authenticated server-side API route)
	export const getSgAddressByPostalCode = async(postalCode) => {
		return new Promise(async (resolve, reject) => {
			try {
				const controller = new AbortController();
				const timeoutId = setTimeout(() => controller.abort(), 8000); // 8 second timeout
				
				const response = await fetch(
					`/api/onemap-address?postalCode=${postalCode}`,
					{ signal: controller.signal }
				);
				
				clearTimeout(timeoutId);

				if (!response.ok) {
					throw new Error(`API error! Status: ${response.status}`);
				}

				const data = await response.json();
				
				if (data && data.found > 0) {
					const result = data.results[0];
					
					// Find the result that matches the postal code exactly
					const exactMatch = data.results.find(r => r.POSTAL === postalCode);
					const addressData = exactMatch || result;
					
					// Ignore building if it's "NIL"
					const building = addressData.BUILDING && addressData.BUILDING !== "NIL" ? addressData.BUILDING : "";
					
					// Format: BLK_NO + ROAD_NAME (and building if not NIL)
					const blkStreet = addressData.BLK_NO && addressData.ROAD_NAME 
						? `${addressData.BLK_NO} ${addressData.ROAD_NAME}`
						: addressData.ROAD_NAME || "";
					
					const formattedAddress = building 
						? `${blkStreet}, ${building}`
						: blkStreet;
					
					resolve({
						success: true,
						address: formattedAddress,
						blkStreet: blkStreet,
						fullAddress: addressData.ADDRESS,
						blkNo: addressData.BLK_NO || "",
						roadName: addressData.ROAD_NAME || "",
						building: building,
						postal: addressData.POSTAL,
						latitude: parseFloat(addressData.LATITUDE),
						longitude: parseFloat(addressData.LONGITUDE)
					});
				} else {
					reject({
						success: false,
						message: "Invalid postal code"
					});
				}
			} catch (error) {
				console.error("OneMap API error:", error);
				if (error.name === 'AbortError') {
					reject({
						success: false,
						message: "Service unavailable."
					});
				} else {
					reject({
						success: false,
						message: "Invalid postal code"
					});
				}
			}
		});
	};
	
	export const reqGoogleLocationAutocomplete = (googleCountryCd) => {
    	//Google Places Autocomplete starts//
    	 
    	 let pac_input = document.getElementById('searchLocationField');
    	 
    	 (function pacSelectFirst(input){
    		    // store the original event binding function
    		    let _addEventListener = (input.addEventListener) ? input.addEventListener : input.attachEvent;
    		    function addEventListenerWrapper(type, listener) {
    		    // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
    		    // and then trigger the original listener.
    		
    		    if (type == "keydown") {
    		      let orig_listener = listener;
    		      listener = function (event) {
    		        let suggestion_selected = $(".pac-item-selected").length > 0;
    		        if (event.which == 13 && !suggestion_selected) {
    		          let simulated_downarrow = $.Event("keydown", {keyCode:40, which:40})
    		          orig_listener.apply(input, [simulated_downarrow]);
    		        }
    		
    		        orig_listener.apply(input, [event]);
    		      };
    		    }
    		
    		    // add the modified listener
    		    _addEventListener.apply(input, [type, listener]);
    		  }
    		
    		  if (input.addEventListener)
    		    input.addEventListener = addEventListenerWrapper;
    		  else if (input.attachEvent)
    		    input.attachEvent = addEventListenerWrapper;
    		
    		})(pac_input);
    		
    		
    		$(function(){
    		  let autocomplete = new google.maps.places.Autocomplete(pac_input);
    		  autocomplete.setComponentRestrictions(
    		            {'country': [googleCountryCd]});
    		});
    	
    	//Google places Autocomplete ends//
    }
	
	export const loadGoogleLocationAutocomplete = (googleCountryCd) => {
		return reqGoogleLocationAutocomplete(googleCountryCd);
	}
